import React from 'react'
import {
    ContainerFluid,Container, HeadingText,HeadingTextX,FeaturedBanner, ExcaptText,Button
} from './FeatureSlidesComponent.style';

function FeatureSlidesComponent() {
  return (
    <div>
        <ContainerFluid>
            <Container>
                

                <div className='row'>
                    <div className='col 12'>
                        <HeadingText>
                            Featured
                        </HeadingText>
                    </div><br/>
                    
                </div>

                <div className='row mb-100'>
                    <div className='col s12 m12 l7'>
                        <FeaturedBanner>

                        </FeaturedBanner>
                    </div>
                    <div className='col s12 m12 l5'>
                        <br/><br/><br/>
                        <HeadingTextX>
                            5 ways to save and invest 
                        </HeadingTextX>
                        <div className='row'>
                            <div className='col s12 m12 l9'>
                            <ExcaptText>
                                Lorem ipsum dolor sit amet, consecte
                                tur adipiscing elit. Sit nulla vitae venen
                                mauris consequat eget Lorem ipsum 
                                dolor sit amet, consectetur adip elit.....
                            </ExcaptText>
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col s12'>
                                <Button to='/'>
                                    Continue Reading
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
                
            </Container>
        </ContainerFluid>
    </div>
  )
}

export default FeatureSlidesComponent